/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

enum Personas {
  HoneywellAdmin = "Honeywell Admin",
  TenantAdmin = "Tenant Admin",
  DistributorAdmin = "Distributor Admin",
  OrganizationAdmin = "Organization Admin",
  OrganizationUser = "Organization User",
  NoAccess = "no Access",
}

export default Personas;
